import { useState } from 'react';
import { Box, Table, TableBody, TableHead, TableRow } from '@mui/material';
import { HeadTableCell, RowTableCell, DialogBody, ActionIconButton } from '../../../common/components';

// Diálogo específico para valores PEI
import PeiValueDialog from '../dialogs/PeiValueDialog';

/**
 * Tab de valores PEI refactorizada siguiendo los patrones del proyecto
 */
const PeiValuesTab = ({ data, selectedPlan }) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedLegalEntity, setSelectedLegalEntity] = useState(null);

  const handleEdit = (entity) => {
    setSelectedLegalEntity(entity);
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setSelectedLegalEntity(null);
  };

  return (
    <DialogBody sx={{ p: 2, minHeight: '65vh' }}>
      <Box>
        <Table>
          <TableHead>
            <TableRow>
              <HeadTableCell>Entidad Intermedia</HeadTableCell>
              <HeadTableCell>Acciones</HeadTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((entity, key) => (
              <TableRow key={key}>
                <RowTableCell>{entity.legal_business_name}</RowTableCell>
                <RowTableCell>
                  <ActionIconButton variant="edit" onClick={() => handleEdit(entity)} />
                </RowTableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>

        <PeiValueDialog 
          open={dialogOpen}
          onClose={handleCloseDialog}
          legalEntity={selectedLegalEntity}
          selectedPlan={selectedPlan} 
        />
      </Box>
    </DialogBody>
  );
};

export default PeiValuesTab;
